// Official supplied brand assets — authoritative, do not recolor or redesign.
export const ASSETS = {
  logoSkyline: "https://customer-assets-7cd3h4nn.emergentagent.net/job_b5792707-12a2-441f-b0b1-72386e62d731/artifacts/7erf11u4_03_Caught_Up_International_Visual_Reference.webp",
  blueCard: "https://customer-assets-7cd3h4nn.emergentagent.net/job_b5792707-12a2-441f-b0b1-72386e62d731/artifacts/tub82h4k_01_Caught_Up_Official_Blue_Membership_Card.png",
  ceoPortrait: "/ceo-andrea-freestone.jpg",
  brandRef: "https://customer-assets-7cd3h4nn.emergentagent.net/job_b5792707-12a2-441f-b0b1-72386e62d731/artifacts/veln52up_02_Caught_Up_Black_Gold_Brand_Reference.png",
};

export const HUBS = ["London", "Moscow", "Palermo", "Dubai"];

export const STATUS_META = {
  application_pending: { en: "Application Pending", it: "Domanda in Attesa", color: "#F59E0B" },
  approved_payment_pending: { en: "Approved — Payment Pending", it: "Approvato — Pagamento in Attesa", color: "#EAB308" },
  active: { en: "Active", it: "Attivo", color: "#10B981" },
  expired: { en: "Expired", it: "Scaduto", color: "#EF4444" },
  suspended: { en: "Suspended", it: "Sospeso", color: "#EF4444" },
};
